import React from 'react';

const Alert = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="12" fill="#EDF7F1" />
        <mask id="alert-mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="5" y="5" width="14" height="14">
            <path fillRule="evenodd" clipRule="evenodd" d="M5.57031 12.0003C5.57031 8.45178 8.45031 5.57178 11.9989 5.57178C15.5475 5.57178 18.4275 8.45178 18.4275 12.0003C18.4275 15.5489 15.5475 18.4289 11.9989 18.4289C8.45031 18.4289 5.57031 15.5489 5.57031 12.0003ZM7.5 12.0008L10.7143 15.2151L16.5 9.42934L15.5936 8.51648L10.7143 13.3958L8.40643 11.0943L7.5 12.0008Z" fill="white" />
        </mask>
        <g mask="url(#alert-mask0)">
            <rect x="4.28906" y="4.28613" width="15.4286" height="15.4286" fill="#79A98C" />
        </g>
    </svg>
);

export default Alert;